import {createFileRoute} from '@tanstack/react-router';
import {HomeLayout} from '@features/flow/components/HomeLayout';
import {HomeView} from '@features/flow/components/HomeView';

export const Route = createFileRoute('/')({
  component: HomePage,
});

function HomePage() {
  return (
    <HomeLayout currentView='home'>
      <title>Banani | Home</title>
      <HomeView />
    </HomeLayout>
  );
}
